<mat-form-field class="home365-select-search-field flex2"  [ngClass]="{'push-up': newStyles, 'light-blue-style no-underline': newBlueLightStyle}">
  <mat-select panelClass="home365-select-search-panel home365-select-custom-height" [formControl]="countriesControl" 
    (openedChange)="selectPanel($event)">
    <mat-select-trigger>
      <div class="flex center-vr country-option-container">
<!--        alt="{{countriesControl.value.countryName}} flag"-->
        <img class="flag-icon flag-icon-selected" src="../../../assets/img/flags/{{countriesControl.value?.icon}}">
        <span>{{countriesControl.value.phonePrefix}}</span>
        <span class="iso" *ngIf="!isMobile">{{countriesControl.value.iso}}</span>
      </div>
    </mat-select-trigger>
    <mat-option disabled class="no-hover home365-select-search-option">
        <!-- <mat-form-field class="countryCodeInput"> -->
          <!-- <mat-label class="colder"></mat-label> -->
          <div class="inputBox">
            <input autofocus class="countryCodeInput" autocomplete="off" type="text" placeholder="{{'COUTRY_CODE.PLACEHOLDER' | translate}}" [formControl]="countriesSearchControl">
            <div class="inputIconBox">
              <i *ngIf="countriesSearchControl.value" class="fa-solid fa-xmark pointer" (click)="countriesSearchControl.setValue(null)"></i>
              <i *ngIf="!countriesSearchControl.value" class="fa-solid fa-magnifying-glass"></i>
            </div>
          </div>
        
        <!-- </mat-form-field> -->
    </mat-option>
    <mat-option *ngFor="let country of countriesList$ | async" [value]="country">
      <div class="flex center-vr country-option-container">
        <img class="flag-icon" src="../../../assets/img/flags/{{country.icon}}">
<!--        <span class="bolder">{{country.countryName}}: {{country.iso}}</span>-->
        <span class="hide-when-selected">{{country.countryName}}:</span><span>{{country.phonePrefix}}</span>
        <!-- <span class="hide-when-selected">{{phoneNumberControl?.value}}</span> -->
      </div>
    </mat-option>
  </mat-select>
</mat-form-field>
<mat-form-field class="flex3" [ngClass]="{'home365-inter-phone-input': !newStyles, 'light-blue-style no-underline': newBlueLightStyle}"
                [floatLabel]="floatLabelValue">
  <mat-label *ngIf="label">{{label}}</mat-label>
  <input (click)="click($event)" matInput type="number" [formControl]="phoneNumberControl" (focus)="inputFocusState(true)" (blur)="inputFocusState(false)" inputmode="numeric">
  <mat-error *ngIf="phoneNumberControl.invalid">{{errorMsg}}</mat-error>
</mat-form-field>
